import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import "normalize.css";

// TODO: vue-script2

createApp(App).use(router).mount("#app");
